// ©2024 Austin App House. All rights reserved.
import React from 'react';
import { MDBCol, MDBInput, MDBRow } from 'mdbreact';
import FilePreviewElement from '../FilePreviewElement';

class UploadDocumentsToWorkOrder extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      imgSrc: [],
    };
  }

  componentWillUnmount() {
    // eslint-disable-next-line react/destructuring-assignment
    this.props.getUploadedDocuments([]);
  }

  handleFileUpload = (event) => {
    const file = event.target.files;
    if (file.length > 0) {
      const reader = new FileReader();
      reader.readAsDataURL(file[0]);
      const imageNameSplittedArray = file[0].name.split('.');
      const fileType = (
        imageNameSplittedArray[imageNameSplittedArray.length - 1] === 'png'
        || imageNameSplittedArray[imageNameSplittedArray.length - 1] === 'jpg'
        || imageNameSplittedArray[imageNameSplittedArray.length - 1] === 'jpeg'
        || imageNameSplittedArray[imageNameSplittedArray.length - 1] === 'bmp'
      ) ? 'image' : 'file';
      reader.onloadend = () => {
        this.setState(cur => ({
          imgSrc: [...cur.imgSrc, {
            type: fileType,
            file: reader.result,
            name: file[0].name,
          }],
        }));
      };
      // eslint-disable-next-line react/destructuring-assignment
      this.props.getUploadedDocuments([...this.props.documents, file[0]]);
    }
  }

  removeImage = (index) => {
    // eslint-disable-next-line react/destructuring-assignment
    this.props.getUploadedDocuments(this.props.documents.filter((el, i) => i !== index));
    this.setState(cur => ({
      imgSrc: cur.imgSrc.filter((el, i) => i !== index),
    }));
  }

  render() {
    const {
      imgSrc,
    } = this.state;

    return (

      <MDBCol>
        <MDBRow className="no-margins">
          <MDBCol md="4">
            <label className="standard_btn icon_upload">
              <input
                type="file"
                className="form-control uploadcheck font11"
                placeholder="Upload file"
                onChange={this.handleFileUpload}
              />
              Upload Documents
            </label>

          </MDBCol>
          <div className="field_row">
            <div className="field_name">
              <label htmlFor="variablePay">Deliverables Required</label>
            </div>
            <div className="field_block">
            <label htmlFor="uploadDocumentsCheckbox" className="check_btn">
              <input
                type="checkbox"
                id="isNeedDeliverables"
                name="isNeedDeliverables"
              />
              Deliverables Required
            </label>
            </div>
          </div>
          
        </MDBRow>
        <MDBRow className="h-paddings-half">
          {
            imgSrc.map((data, i) => (
              FilePreviewElement({
                fileInfo: data,
                index: i,
                data,
                toggleModal: this.props.toggleModal,
                removeImage: this.removeImage,
              })
            ))
          }
        </MDBRow>
      </MDBCol>
    );
  }
}

export default UploadDocumentsToWorkOrder;
